<template>
  <div>
    <full-calendar
      v-loading="loading"
      class="test-fc"
      :events="calenderData"
      first-day="1"
      locale="zh-cn"
      :week-numbers="weekNumbers"
      @changeMonth="changeMonth"
      @eventClick="eventClick"
      @dayClick="dayClick"
      @moreClick="moreClick"
    >
      <template #fcEventCard="scope">
        {{ scope.event.title }}
      </template>
      <!-- 单个事件弹出成 -->
      <template #bodyCard>
        <div v-show="singleShow" class="itemSingleEvent" :style="{ left: itemPosition.left + 'px', top: itemPosition.top + 'px' }">
          <div class="card-head">
            <span class="close el-icon-circle-close" @click.stop="singleShow = false" />
          </div>
          <div class="card-main">
            <div class="main-item">
              <span class="el-icon-info" />
              <span>{{ itemData.courseName }}</span>
            </div>
            <div class="main-item">
              <span class="el-icon-date" />
              <span>{{ itemData.start }}</span>
            </div>
            <div class="main-item">
              <span class="el-icon-time" />
              <span>{{ itemData.startTime }} - {{ itemData.endTime }}</span>
            </div>
            <div class="main-item">
              <span class="el-icon-location-information" />
              <span>{{ itemData.address }}</span>
            </div>
            <div class="main-item">
              <div>授课老师:</div>
              <div>{{ itemData.teacher }}</div>
            </div>
            <div class="main-item">
              <div>{{ userType === 'mba' ? '助教' : '带班老师' }}:</div>
              <div>{{ itemData.assistants || '-' }}</div>
            </div>
          </div>
        </div>
      </template>
    </full-calendar>
  </div>
</template>
<script setup>
import FullCalendar from '@/components/FullCalender'
import { ref, computed } from 'vue'
import { CourseHook } from '@/hooks/courseHook'
import Store from '@/store'

const { loading, calenderData, weekNumbers, CourseCalendar } = CourseHook()
const userType = computed(() => Store.getters.userInfo.dean_type || 'mba')
const singleShow = ref(false)

const itemPosition = ref({})
const itemData = ref({})

const changeMonth = (start, end, current) => {
  singleShow.value = false
  CourseCalendar({ start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD') })
}
function eventClick(event, jsEvent, pos) {
  singleShow.value = true
  pos.left -= 210
  pos.top -= 20
  itemPosition.value = pos
  itemData.value = event
}
function dayClick(day, jsEvent) {
  singleShow.value = false
}
function moreClick(day, events, jsEvent) {
  singleShow.value = false
}
</script>

<style lang="scss" scoped>
.itemSingleEvent {
  position: absolute;
  z-index: 2;
  border: 1px solid #eee;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  width: 200px;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 8px;
  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    right: -8px;
    top: 4px;
    border-top: solid 8px transparent;
    border-left: solid 8px #ddd;
    border-bottom: solid 8px transparent;
  }
  .card-head {
    text-align: right;
    .el-icon-circle-close {
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: var(--theme-color);
      }
    }
  }
  .main-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    line-height: 12px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    div {
      &:nth-child(1) {
        flex: 1;
      }
      &:nth-child(2) {
        flex: 2;
      }
      font-size: 12px;
    }
    span {
      font-size: 12px;
      &:nth-child(1) {
        margin-right: 10px;
        color: #b22222;
      }
      &:nth-child(2) {
        font-size: 12px;
      }
    }
  }
}
</style>
